<template>
  <router-view />
</template>
<script>
  export default {
    name: 'players'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/index.vue